let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3xjKC")).then(() => parcelRequire('8q4ic'));